import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import DailySnapshotList from '../Components/DailySnapshotList/index.jsx';

import DailySnapshotService from '../Services/DailySnapshot/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-daily-snapshots';
  }

  renderElement(element) {
    return (
      <Provider store={Store}>
        <DailySnapshotList dailySnapshotService={DailySnapshotService} />
      </Provider>
    );
  }
}


export default EntryPoint;

